module.exports = __webpack_public_path__ + "static/img/03_11.43526fc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/tips/03_11.png
// module id = E+dh
// module chunks = 1